const state = {
    config: []
}

const getters = {
    count: state => {
        return state.config.length;
      },
      getConfig: (state) => {
        return state.config;
      },
}

const mutations = {
    setConfig (state, config) {
        state.config = config;
    },
  }

const actions = {

    retrieveFromLS ({ commit }) {
      let config = JSON.parse(localStorage.getItem('db.estadisticasConfig'));
      if (config) commit('setConfig', config);
    },
  
    setAndPersistLS({ dispatch, commit }, config) {
      commit('setConfig', config);
      dispatch('persistLS');
    },
  
    persistLS({ state }) {
      localStorage.setItem('db.estadisticasConfig', JSON.stringify(state.config));
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}